import { RootState } from "../store";
import { ISettingsState } from "../types/state";

export const getSettingsStatus = (state: RootState): ISettingsState["status"] => state.settings.status;

export const getSettingsErrorMsg = (state: RootState): ISettingsState["errorMsg"] => state.settings.errorMsg;

export const getSettings = (state: RootState): ISettingsState["settings"] => state.settings.settings;
